export default __webpack_public_path__ + "src/assets/membership-twelvemonths.61ffab991365e0eff3d9f6192109f949.svg";